import { GET_BLOGS,GET_BLOGS_ERR } from '../../actionTypes/blogType'
import { getBlogsApi } from 'api/Api';
import axios from "axios";
export const getBlogs = payload => async dispatch => {
    try {
        console.log('payload',payload)
        let results = await axios.get(`${getBlogsApi}/${payload.filter}/${payload.page}`)
        console.log("GET BLOGSz", results)
        let data = results && results.data
        dispatch({
            type: GET_BLOGS,
            payload: data || [],
        });
    } catch (error) {
        dispatch({
            type: GET_BLOGS_ERR,
            payload: error && error.response
        });
    }
}

